import Vue from "vue";

export const dashboardService = {
  getData
};

function getData(params) {
  return Vue.axios.get("v2/admin/dashboard", { params });
}
